import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <img 
          src="/nbc_logo.jpg"
          alt="NBC"
          className="h-16 mx-auto mb-8"
        />

        <div className="animate-fade-in-up">
          <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-white/50" />
          </div>
          <h1 className="text-2xl font-bold uppercase mb-2">Payment Cancelled</h1>
          <p className="text-white/60 mb-8">
            No worries! You can complete your payment anytime.
          </p>

          <div className="space-y-4">
            <Button
              onClick={() => navigate("/")}
              className="bg-[#FFB612] text-black hover:bg-[#E5A00D] font-bold uppercase w-full"
            >
              Return Home
            </Button>
            <Button
              onClick={() => navigate("/dashboard")}
              variant="outline"
              className="border-white/20 text-white w-full"
            >
              Go to Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
